import 'styled-components/macro';
import React from 'react';
import { styled, Typography, useTheme } from '@harver/shared-ui';
import { EmailOutlinedIcon } from '@harver/shared-ui/lib/icons';

import { ContentCard } from '../../../../components/ContentCard';
import { useContent } from '../../../../branding/content.context';
import CookieBanner from '../../../../components/CookieBanner';

const StyledDiamondErrorIcon = styled(EmailOutlinedIcon)`
    font-size: 60px;
    color: #424242;
`;
export function OpenInviteSuccess() {
    const theme = useTheme();
    const { openInviteRegistrationSuccess: SUCCESS } = useContent();
    document.title = SUCCESS.browserTitle;

    return (
        <>
            <ContentCard>
                <div
                    css={{
                        textAlign: 'center',
                        margin: `${theme.sizes.xxxLarge} 0`,
                    }}
                >
                    <StyledDiamondErrorIcon />

                    <Typography
                        testId="openInvite.submit.confirmation"
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.large,
                        }}
                        variant="h3"
                    >
                        {SUCCESS.title}
                    </Typography>
                    <Typography
                        css={{
                            textAlign: 'center',
                            whiteSpace: 'pre-line',
                        }}
                        variant="body1"
                    >
                        {SUCCESS.p1}
                    </Typography>
                </div>
                <CookieBanner />
            </ContentCard>
        </>
    );
}
